import { useState, useEffect } from 'react';
import { FiChevronUp } from 'react-icons/fi';

const ScrollToTopButton = () => {
	const [showScroll, setShowScroll] = useState(false);

	useEffect(() => {
		const handleScroll = () => {
			if (window.pageYOffset > 400) {
				setShowScroll(true);
			} else {
				setShowScroll(false);
			}
		};

		window.addEventListener('scroll', handleScroll);

		return () => {
			window.removeEventListener('scroll', handleScroll);
		};
	}, []); // No need to depend on `showScroll`

	const backToTop = () => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	};

	return (
		<span className="fixed bottom-0 right-1 z-40">
			<FiChevronUp
				className="scrollToTop"
				onClick={backToTop}
				style={{
					height: 45,
					width: 45,
					borderRadius: 50,
					right: 30,
					bottom: 10,
					display: showScroll ? 'flex' : 'none',
					padding: 5,

				}}
			/>
		</span>
	);
};

export default ScrollToTopButton;

